export const FETCH_CARRIER_PROPERTIES_URL =
  "/ifx/api/common/util/fetch/carrierProperties.do";

export const FETCH_CARRIER_PROPERTIES_BY_CARRIER_URL =
  "/ifx/api/common/util/fetch/carrierPropertyByCarriers.do";

export const DOWNLOAD_CENTER_URL = "/ifx/documentCenter.do";

export const DOWNLOAD_CENTER_POLL_URL =
  DOWNLOAD_CENTER_URL + "?requestType=polling";

export const DOWNLOAD_CENTER_DOWNLOAD_FILE_URL =
  "/ifx/documentCenterFileDownload.do";

export const FETCH_CODE_VAL_URL = "/ifx/api/common/util/fetch/codeVal.do";

export const FETCH_USER_STATIONS_URL =
  "/ifx/api/common/util/fetch/userStations.do";

export const GET_BUILD_INFO_URL = "/ifx/api/buildInfo.do";
export const GET_GP_BUILD_INFO_URL = "/gp-react/build-info.json";
export const GET_ASM_MENU = "/asm-react/app/asm/public/json/asm-nav-item.json";

export const ESO_SERVICE_CODES_FOR_POPUP_URL =
  "/ifx/api/esm/common/serviceCode/lookup.do";

export const REPORTS_DOWNLOAD_URL = "/ifx/adm/reports/download.do";

export const REPORTS_SEND_TO_DOWNLOAD_CENTER_URL =
  "/ifx/adm/reports/downloadCenter.do";

export const REPORTS_ADD_SCHEDULER_URL = "/ifx/adm/reports/addScheduler.do";

export const GET_HELP_LINK =
  "/ifx/api/common/help/userFunctionalHelp/getAllLinks.do";

export const USER_MANUAL_ACCESS_URL =
  "/ifx/api/common/helpPage/access.do";

export const SAVE_AND_UPDATE_HELP_LINK =
  "/ifx/api/common/help/userFunctionalHelp/save.do";

export const DELETE_HELP_LINK =
  "/ifx/api/common/help/userFunctionalHelp/delete.do";


export const GET_DOCUMENT = (docSourceType) => `/ifx/api/common/doc/${docSourceType}/list`;

export const DELETE_DOCUMENT = (docSourceType) => `/ifx/api/common/doc/${docSourceType}/delete.do`;

export const UPLOAD_DOCUMENT = (docSourceType) => `/ifx/api/common/doc/${docSourceType}/upload/temp.do`;

export const UPLOAD_DOCUMENT_SAVE = (docSourceType) => `/ifx/api/common/doc/${docSourceType}/upload/save.do`;

export const DOWNLOAD_DOCUMENT = (docSourceType) => `/ifx/api/common/doc/${docSourceType}/download/`;

export const TEMP_DELETE_DOCUMENT = (docSourceType) => `/ifx/api/common/doc/${docSourceType}/delete/temp.do`;

export const DOCUMENT_COUNT_UPDATE = "/ifx/api/esm/spec/update/docCount";

export const GET_DOCUMENT_COUNT = (docSourceType) => `/ifx/api/common/doc/${docSourceType}/count`;


